import React from "react";

import Search from "@/components/reusables/data-table/SearchFunction";
import { H3 } from "@/components/reusables/typography";
import { driveTypes } from "@/constants/constant-values/default-values.constant";
import { ViewToggle, ViewType } from "@/pages/drive/ViewToggle";

interface DriveHeaderProps {
  isManager: boolean;
  type: string;
  viewType?: ViewType;
  setViewType?: (viewType: ViewType) => void;
  onSearch: (search: string) => void;
  children?: React.ReactNode;
}

export const DriveHeader: React.FC<DriveHeaderProps> = ({
  isManager,
  type,
  viewType,
  setViewType,
  onSearch,
  children,
}) => {
  const getDriveTypeName = (): string => {
    if (type === driveTypes.PROJECT) {
      return "Project";
    }
    if (type === driveTypes.TASK_AND_CLAIMS) {
      return "Task And Claims";
    }
    if (type === driveTypes.PROJECT_REGISTER) {
      return "Project Register";
    }

    return type;
  };

  return (
    <div className='relative'>
      <div className='flex flex-wrap items-center justify-between space-x-2 mt-4 mb-4'>
        {/* Left section */}
        <div className='flex items-center space-x-2'>
          {isManager ? (
            <H3 className='text-gray-700'>{getDriveTypeName()}</H3>
          ) : (
            children
          )}
        </div>

        {/* Right section */}
        <div className='flex items-center space-x-4 ml-auto'>
          <Search
            search='Search files and folders'
            updateParams={(key, value) => {
              if (key === "search") {
                onSearch(value as string);
              }
            }}
          />
          {viewType && setViewType && (
            <ViewToggle viewType={viewType} setViewType={setViewType} />
          )}
        </div>
      </div>
    </div>
  );
};
